// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthLayout_wrapper__2XE60","card":"AuthLayout_card__3nSHH","body":"AuthLayout_body__nib0f"};